import { IXF_ACCOUNTING_V1_MANUAL_ENTRY_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixf-accounting-v1-manual-entry-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxfAccountingV1ManualEntryStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../../util/entity-status-variants';

interface AccountingManualEntryStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxfAccountingV1ManualEntryStatus | undefined;
}

export function AccountingManualEntryStatusPill({ isPending, status, ...props }: AccountingManualEntryStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXF_ACCOUNTING_V1_MANUAL_ENTRY_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixfAccountingV1', enumName: 'IxfAccountingV1ManualEntryStatus', value: status }} />
    </Pill>
  );
}
